const ProductionStatisticsSummaryData = (props) => {
  const { data } = props;
  const uniqueRows = [];
  const dataRows = data?.map((row) => { 
    const id = row.npn + row.carrierName + row.salesYear;  
    return {
      id: id,
      agentName: row.agentName,
      npn: row.npn,
      carrierName: row.carrierName,
      maTotal: row.maTotal,
      medsuppTotal: row.medsuppTotal,
      pdpTotal: row.pdpTotal,
      salesYear: row.salesYear,
      uplines: row.uplines,
    };    
  });

  dataRows.forEach((row) => {
    if (!uniqueRows.find((existingRow) => existingRow.id === row.id)) {
      uniqueRows.push(row);
    }
  });

  return uniqueRows;
};

export default ProductionStatisticsSummaryData;
